var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGraduationCap = function SvgIconGraduationCap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.517 2.124a1 1 0 0 1 .966 0l10.875 6a1 1 0 0 1 0 1.752L22 10.625v4.863c0 .413-.148.813-.418 1.127-.417.493-1.464 1.607-3.145 2.573V22.5a1 1 0 1 1-2 0v-2.385c-1.257.453-2.735.76-4.437.76-5.585 0-8.772-3.303-9.582-4.26A1.73 1.73 0 0 1 2 15.488v-4.863l-1.358-.75a1 1 0 0 1 0-1.75zM3.549 9.195a1 1 0 0 0-.136-.075L3.195 9 12 4.142 20.805 9l-.218.12a1 1 0 0 0-.136.075l-3.014 1.663-4.954-2.734a1 1 0 0 0-.966 1.752L15.367 12 12 13.858zM4 11.728v3.66c.731.84 3.393 3.487 8 3.487 1.764 0 3.243-.388 4.438-.914v-4.267l-3.955 2.182a1 1 0 0 1-.966 0zm14.438 5.078A9.7 9.7 0 0 0 20 15.388v-3.66l-1.562.862z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGraduationCap;